import React from "react";
import FireboardUtil from "../../../../../util/fireboard-util";
import constants from "../../../../../globalization";
import CheckItems from "./CheckItems";
import classes from './CheckDetails.module.css';
import classNames from 'classnames';
import CheckSummary from "../CheckSummary";

const CheckDetails = (props) => {
  const {
    selectedItem = {},
    supportsTipsOnTotalAmount = false,
    suppressTipsOnFireBoard,
    items = [],
    currency,
    checkDetailsStyles = {},
    onPay,
    onSplitPay,
  } = props || {};
  
  const isPOSOrder =
  FireboardUtil.getOrderTypeFromSourceType(selectedItem.sourceType) === constants.orderType_POS;

  const paymentDisabled = !(!!selectedItem.unpaidAmount);
  
  const renderButtons = () => (
    <div className={classes.buttonContainer}>
    <button
      className={classNames({ [classes.buttonWrapper]: true, [classes.disabled]: paymentDisabled, [classes.disabledBtn]: paymentDisabled, [classes.paymentBtn]: true })}
      onClick={() => onPay(selectedItem)}
      disabled={paymentDisabled}
    >
      <span
        className={classNames({ [classes.paymentTxt]: true, [classes.paymentDisabledTxt]: paymentDisabled })}
      >
        PAYMENT
      </span>
    </button>
    {/* <div className={classes.divider}></div>
        <button
        className={classNames({ [classes.buttonWrapper]: true, [classes.disabled]: paymentDisabled, [classes.disabledBtn]: paymentDisabled, [classes.splitOptions]: true })}
        onClick={() => onSplitPay(selectedItem)}
        disabled={paymentDisabled}
      >
        <span
          className={classNames({ [classes.paymentTxt]: true, [classes.paymentDisabledTxt]: paymentDisabled })}
        >
          SPLIT
        </span>
      </button> */}
      </div>
  );

  return (
    <div className={[classes.checkDetails, checkDetailsStyles].join(' ')}>
      <CheckItems
        posItemKeys={isPOSOrder && Object.keys(items).sort()}
        items={items}
        selectedItem={selectedItem}
        currency={currency}
      />
      <CheckSummary
        selectedItem={selectedItem}
        supportsTipsOnTotalAmount={supportsTipsOnTotalAmount}
        currency={currency}
        suppressTipsOnFireBoard={suppressTipsOnFireBoard}
        bottomContainerStyle={classes.bottomContainer}
      />
      {renderButtons()}
    </div>
  );
};

export default CheckDetails;
